/*  Если нужен мультиселект с меньшим скруглением borderRadius то советую использовать или dt или pt стилизацию в primevue


 */
export const root = {
  background: 'white',
  disabledBackground: '{form.field.disabled.background}',
  filledBackground: '{form.field.filled.background}',
  filledHoverBackground: '{form.field.filled.hover.background}',
  filledFocusBackground: '{form.field.filled.focus.background}',
  borderColor: '#e6e3ec',
  hoverBorderColor: 'rgba(162, 184, 233, 1)',
  focusBorderColor: 'rgba(162, 184, 233, 1)',
  invalidBorderColor: '{form.field.invalid.border.color}',
  color: '{form.field.color}',
  disabledColor: '{form.field.disabled.color}',
  placeholderColor: '{form.field.placeholder.color}',
  invalidPlaceholderColor: '{form.field.invalid.placeholder.color}',
  shadow: '{form.field.shadow}',
  paddingX: '12px',
  paddingY: '12px',
  borderRadius: '40px',
  focusRing: {
    width: '2px',
    style: '{form.field.focus.ring.style}',
    color: 'rgba(35, 47, 69, 0.4);',
    offset: '{form.field.focus.ring.offset}',
    shadow: '{form.field.focus.ring.shadow}'
  },
  transitionDuration: '{form.field.transition.duration}',
  sm: {
    fontSize: '{form.field.sm.font.size}',
    paddingX: '{form.field.sm.padding.x}',
    paddingY: '{form.field.sm.padding.y}'
  },
  lg: {
    fontSize: '{form.field.lg.font.size}',
    paddingX: '{form.field.lg.padding.x}',
    paddingY: '{form.field.lg.padding.y}'
  }
};

export const dropdown = {
  width: '2.5rem',
  color: '{form.field.icon.color}'
};

export const overlay = {
  background: '{overlay.select.background}',
  borderColor: '{overlay.select.border.color}',
  borderRadius: '{overlay.select.border.radius}',
  color: '{overlay.select.color}',
  shadow: '{overlay.select.shadow}'
};

export const list = {
  padding: '{list.padding}',
  gap: '{list.gap}',
  header: {
    padding: '{list.header.padding}'
  }
};

export const option= {
  focusBackground: '{list.option.focus.background}',
  selectedBackground: '{list.option.selected.background}',
  selectedFocusBackground: '{list.option.selected.focus.background}',
  color: '{list.option.color}',
  focusColor: '{list.option.focus.color}',
  selectedColor: '{list.option.selected.color}',
  selectedFocusColor: '{list.option.selected.focus.color}',
  padding: '{list.option.padding}',
  borderRadius: '{list.option.border.radius}',
  gap: '0.5rem'
};

export const optionGroup = {
  background: '{list.option.group.background}',
  color: '{list.option.group.color}',
  fontWeight: '{list.option.group.font.weight}',
  padding: '{list.option.group.padding}'
};

export const clearIcon = {
  color: '{form.field.icon.color}'
};

export const chip = {
  borderRadius: '{border.radius.sm}'
};

export const emptyMessage = {
  padding: '{list.option.padding}'
};

export default {
  root,
  dropdown,
  overlay,
  list,
  option,
  optionGroup,
  chip,
  clearIcon,
  emptyMessage
}